import React, { Component } from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { log, post, get } from '../../util/api';
import { Button, Segment, Table, Grid, GridColumn, Form, Header, Checkbox, Dropdown, Modal, Icon, Popup, Input, Label, Divider } from 'semantic-ui-react';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import tr from 'date-fns/locale/tr';
import en from 'date-fns/locale/en-GB';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';
import de from 'date-fns/locale/de';

const dateLocales = { tr, en, es, pt, ru, fr, de };

const filterPassedTime = (time) => {
	const currentDate = new Date();
	const selectedDate = new Date(time);
	return currentDate.getTime() < selectedDate.getTime();
};

// Gönderim aralığı seçenekleri
const time_options = [];
function formatTime(value) {
	let dur = moment.duration(value);
	return moment(dur._data.minutes, 'm').format('mm') + ':' + moment(dur._data.seconds, 's').format('ss');
}
for (var i = 1; i <= 40; i++) {
	time_options.push({ key: '' + i * 15, text: formatTime(i * 15000), value: i * 15000 });
}

// Telegram HTML formatını escape etme
const escapeHTML = function (text) {
	if (!text) return text;
	const escaped = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
	};
	return String(text).replace(/[&<>]/g, (char) => escaped[char] || char);
};

// Telegram HTML formatını uygulama
const applyTelegramFormatting = (text) => {
	if (!text) return text;

	let formatted = text;

	formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
	formatted = formatted.replace(/\*(.*?)\*/g, '<b>$1</b>');
	formatted = formatted.replace(/__(.*?)__/g, '<i>$1</i>');
	formatted = formatted.replace(/_(.*?)_/g, '<i>$1</i>');
	formatted = formatted.replace(/~~(.*?)~~/g, '<u>$1</u>');
	formatted = formatted.replace(/~(.*?)~/g, '<s>$1</s>');
	formatted = formatted.replace(/`(.*?)`/g, '<code>$1</code>');
	formatted = formatted.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

	return formatted;
};

class TelegramBroadcast extends Component {
	state = {
		startDate: new Date(),
		loading: true,
		targets: [],
		message_type: 'text',
		parse_mode: 'HTML',
		start_date: new Date(),
		lasttime: new Date(),
		selectedTag: 'all',
		message: '',
		caption: '',
		selectedTelegram: null,
		phoneSource: 'contacts',
		sending_date: 'now',
		selectedAralik: 20 * 15000,
		excelpage: 0,
		telegram_type: 'telegram',
		webApiPhones: [],
		selectedWebApiPhone: null,
		webApiExcelData: [],
		webApiExcelLoading: true,

		inline_keyboard: [],
		button_text: '',
		button_type: 'url',
		button_url: '',
		button_callback_data: '',
		current_row: [],

		reply_keyboard: [],
		reply_button_text: '',
		keyboard_type: 'none',

		btnLoading: false,
		openModal: false,
		openTestModal: false,
		openKeyboardModal: false,
		testNumber: '',
		excelLoading: true,
	};

	async componentDidMount() {
		let { product } = this.props;
		await this.getTelegramList();
		await this.getContactList();
		await this.getListExcel();
		await this.getWebApiIntegrations();
		await this.getWebApiContactList();
		await this.getListTable();
		await this.getSchedulesList();

		this.setState({ loading: false });
	}

	async getSchedulesList() {
		const { product } = this.props;
		let pid = product.id;
		log('/api/listSchedules', {
			pid,
			limit: 1,
		}).then((data) => this.setState({ job_list: data.data.result }));
	}

	async getTelegramList() {
		let { product } = this.props;
		let pid = product.id;
		await post('/broadcast/telegramList', { pid }).then((data) => {
			let telegrams = data.data.telegrams;
			let telegramList = [];
			if (telegrams && telegrams.length) {
				telegramList = _.map(telegrams, (it) => ({
					value: it.id,
					text: it.name,
				}));
			}
			this.setState({
				telegramList,
				selectedTelegram: telegramList && telegramList[0] && telegramList[0].value,
			});
		});
	}

	async getContactList() {
		let { product } = this.props;
		let pid = product.settings.live.token;

		await fetch('https://live.dahi.ai/blacklist/list', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ pid }),
		})
			.then((response) => response.json())
			.then((data) => {
				this.setState({ blackList: data.result });
			});

		await fetch('https://live.dahi.ai/analytics/dialogtab/userLabelList', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ pid }),
		})
			.then((response) => response.json())
			.then((data) => {
				this.setState({ telegramContactList: data.data });
			});

		await post('/dahi/tag/list', {}).then((data) => {
			this.setState({ tagList: data.data.result.result });
		});
	}

	async getListExcel() {
		const { product } = this.props;
		let pid = product.id;
		fetch(`https://micro.yapaytech.com/api/forex_contacts/readMulti?pid=${pid}&key=telegramList`)
			.then((response) => response.json())
			.then((data) => {
				let result = data.result;
				let excelData = result;
				_.map(excelData, (it) => {
					_.map(it.data, (o) => {
						if (o.Etiket) o.tags = o.Etiket.split(',');
					});
				});
				this.setState({ excelData, excelLoading: false });
			});
	}

	async getListTable() {
		const { product } = this.props;
		let pid = product.id;
		if (product.settings.merged_broadcast_list)
			await post('/broadcast/listBroadcastUser', { pid }).then((data) => {
				let list = data.data.result;
				let merged_excel_list =
					(list &&
						list.length &&
						_.map(list, (it) => ({
							Name: it.name,
							Phone: it.phone,
							tags: it.data.tag,
						}))) ||
					[];
				this.setState({ merged_excel_list });
			});
	}

	async getWebApiIntegrations() {
		await get('/telegramController/getIntegrations')
			.then((res) => {
				if (!res || res.success !== true) return;
				let webApiIntegrations = _.map(res.data, (it) => ({
					value: it.id,
					text: it.name || it.username || 'ID: ' + it.id,
				}));
				this.setState({
					webApiIntegrations,
					selectedWebApiIntegration: webApiIntegrations[0] && webApiIntegrations[0].value,
				});
			})
			.catch(() => {});
	}

	async getWebApiContactList() {
		const { product } = this.props;
		let pid = product.id;
		fetch(`https://micro.yapaytech.com/api/forex_contacts/readMulti?pid=${pid}&key=contactList`)
			.then((response) => response.json())
			.then((data) => {
				let webApiExcelData = data.result;
				_.map(webApiExcelData, (it) => {
					_.map(it.data, (o) => {
						if (o.Etiket) o.tags = o.Etiket.split(',');
					});
				});
				this.setState({ webApiExcelData, webApiExcelLoading: false });
			});
	}

	addInlineButton = () => {
		let { button_text, button_type, button_url, button_callback_data, current_row } = this.state;

		if (!button_text) {
			alert('Buton metni gerekli!');
			return;
		}

		let button = { text: button_text };

		if (button_type === 'url') {
			if (!button_url) {
				alert('URL gerekli!');
				return;
			}
			button.url = button_url;
		} else if (button_type === 'callback_data') {
			button.callback_data = button_callback_data || button_text;
		}

		current_row.push(button);
		this.setState({
			current_row,
			button_text: '',
			button_url: '',
			button_callback_data: '',
		});
	};

	finishRow = () => {
		let { current_row, inline_keyboard } = this.state;

		if (current_row.length > 0) {
			inline_keyboard.push([...current_row]);
			this.setState({
				inline_keyboard,
				current_row: [],
			});
		}
	};

	clearKeyboard = () => {
		this.setState({
			inline_keyboard: [],
			current_row: [],
			reply_keyboard: [],
		});
	};

	async sendMessage(isTest = false) {
		let {
			targets,
			message,
			caption,
			message_type,
			selectedTelegram,
			selectedWebApiIntegration,
			telegram_type,
			startDate,
			sending_date,
			testNumber,
			parse_mode,
			inline_keyboard,
			keyboard_type,
			job_list,
			header_image,
			selectedAralik,
		} = this.state;

		this.setState({ btnLoading: true });
		let { product } = this.props;
		let pid = product.id;
		let uid = product.uid;

		let diff_minute = moment(startDate).diff(moment(), 's');
		let start_time = sending_date === 'now' ? 1 : Math.max(diff_minute, 1);
		let hash = '' + new Date().getTime();

		if (isTest) {
			targets = [
				{
					id: testNumber,
					name: testNumber,
					Phone: testNumber,
				},
			];
		}

		let content = {
			type: message_type,
		};

		switch (message_type) {
			case 'text':
				if (header_image && parse_mode === 'HTML') {
					content.type = 'image';
					content.url = header_image;
					content.caption = message;
					if (parse_mode) content.parse_mode = parse_mode;
				} else {
					content.text = message;
					if (parse_mode) content.parse_mode = parse_mode;
				}
				break;
			case 'image':
			case 'video':
			case 'document':
			case 'audio':
			case 'animation':
				content.url = message;
				if (caption) {
					content.caption = caption;
					if (parse_mode) content.parse_mode = parse_mode;
				}
				break;
			default:
				content.text = message;
		}

		if (keyboard_type === 'inline' && inline_keyboard.length > 0) {
			content.reply_markup = {
				inline_keyboard: inline_keyboard,
			};
		}

		let new_id_ob = _.maxBy(job_list, (it) => it.data.event && it.data.event.extra && parseInt(it.data.event.extra.id.replace(/.*_/, '')));
		let new_id = (new_id_ob && new_id_ob.data && new_id_ob.data.event && parseInt(new_id_ob.data.event.extra.id.replace(/.*_/, ''))) || 0;

		let activeTelegramId = telegram_type === 'telegramv2' ? selectedWebApiIntegration : selectedTelegram;
		let extra = {
			source: telegram_type === 'telegramv2' ? 'telegram_web' : 'telegram',
			telegram_id: activeTelegramId,
			numbers: _.map(targets, (it) => ({
				id: it.Phone || it.id,
				name: it.Name || it.name || it.id,
			})),
			start_time,
			id: activeTelegramId + '_' + (new_id + 1),
			content,
			singletonMinutes: 1,
			hash,
			seconds: selectedAralik / 1000,
		};

		let logData = {
			message,
			message_type: content.type,
			caption,
			extra,
			groups: _.map(targets, ({ id, name, Phone }) => ({
				id: Phone || id,
				name: name || Phone || id,
			})),
		};

		if (!isTest) {
			await log('/live/groupMessageLog/add', { pid, uid, log: logData });
		}

		await log('/api/addSchedule', {
			category: 'schedule',
			label: 'broadcast_message_event_telegram',
			extra,
			pid,
		});

		this.getSchedulesList();
		this.setState({
			btnLoading: false,
			openModal: false,
			openTestModal: false,
		});
	}

	onEmojiClick = (emoji, event) => {
		let { message } = this.state;
		let textarea = document.getElementById('message_area');
		let start_index = textarea.selectionStart || message.length;
		let native = emoji.native;
		let newMessage = message.substr(0, start_index) + native + message.substr(start_index);
		this.setState({ message: newMessage }, () => {
			textarea.focus();
			let newCursorPos = start_index + native.length;
			textarea.setSelectionRange(newCursorPos, newCursorPos);
		});
	};

	onEmojiClickCaption = (emoji, event) => {
		let { caption } = this.state;
		let textarea = document.getElementById('caption_area');
		let start_index = textarea.selectionStart || caption.length;
		let native = emoji.native;
		let newCaption = caption.substr(0, start_index) + native + caption.substr(start_index);
		this.setState({ caption: newCaption }, () => {
			textarea.focus();
			let newCursorPos = start_index + native.length;
			textarea.setSelectionRange(newCursorPos, newCursorPos);
		});
	};

	addHTMLTag = (tag) => {
		let { message } = this.state;
		let textarea = document.getElementById('message_area');
		let start = textarea.selectionStart;
		let end = textarea.selectionEnd;
		let selectedText = message.substring(start, end);
		let openTag = `<${tag}>`;
		let closeTag = `</${tag}>`;
		let newMessage = message.substring(0, start) + openTag + selectedText + closeTag + message.substring(end);
		this.setState({ message: newMessage });
	};

	addMarkdownTag = (marker) => {
		let { message } = this.state;
		let textarea = document.getElementById('message_area');
		let start = textarea.selectionStart;
		let end = textarea.selectionEnd;
		let selectedText = message.substring(start, end);
		let newMessage = message.substring(0, start) + marker + selectedText + marker + message.substring(end);
		this.setState({ message: newMessage });
	};

	addLink = () => {
		let { message } = this.state;
		let textarea = document.getElementById('message_area');
		let start = textarea.selectionStart;
		let end = textarea.selectionEnd;
		let selectedText = message.substring(start, end);
		let linkTag = `<a href="">${selectedText || 'Link'}</a>`;
		let newMessage = message.substring(0, start) + linkTag + message.substring(end);
		this.setState({ message: newMessage });
	};

	handleChange = (e, { name, value }) => {
		this.setState({ [name]: value });
	};

	fileUpload(file, fieldName = 'message') {
		const url = 'https://uploads.yapaytech.com/flow/uploadImage';
		const formData = new FormData();
		formData.append('files[]', file);

		fetch(url, {
			method: 'post',
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				let image_url = data && data.files && data.files[0] && data.files[0].url;
				this.setState({ [fieldName]: image_url });
			});
	}

	handleFileInput = (e) => {
		let file = e.target.files[0];
		this.fileUpload(file);
	};

	toggle = (item, isChecked) => {
		let { targets } = this.state;
		if (isChecked) {
			targets.push(item);
		} else {
			_.remove(targets, (it) => it.Phone === item.Phone);
		}
		this.setState({ targets });
	};

	toggleAll = (list) => {
		let { targets, blackList } = this.state;
		_.map(list, (it) => {
			let isBlackList = _.includes(blackList, '' + it.Phone);
			let isCheck = _.find(targets, { Phone: it.Phone });
			if (!isCheck && !isBlackList) {
				targets.push(it);
			}
		});
		this.setState({ targets });
	};

	closeModal = () => {
		this.setState({
			openModal: false,
			openListModal: false,
			btnLoading: false,
			openTestModal: false,
			openKeyboardModal: false,
		});
	};

	render() {
		let {
			loading,
			message,
			caption,
			targets,
			btnLoading,
			message_type,
			parse_mode,
			selectedTelegram,
			telegramList,
			startDate,
			sending_date,
			testNumber,
			tagList,
			selectedTag,
			excelData,
			blackList,
			merged_excel_list,
			inline_keyboard,
			button_text,
			button_type,
			button_url,
			button_callback_data,
			current_row,
			keyboard_type,
			telegram_type,
			webApiIntegrations,
			selectedWebApiIntegration,
			webApiExcelData,
			webApiExcelLoading,
		} = this.state;

		let { t, product } = this.props;

		if (loading) return <Page.Loader></Page.Loader>;

		let messageTypes = [
			{ value: 'text', text: 'Metin' },
			{ value: 'image', text: 'Resim' },
			{ value: 'video', text: 'Video' },
			{ value: 'document', text: 'Doküman' },
			{ value: 'audio', text: 'Ses' },
			{ value: 'animation', text: 'GIF/Animasyon' },
		];

		let parseModes = [
			{ value: '', text: 'Yok' },
			{ value: 'HTML', text: 'HTML' },
			{ value: 'MarkdownV2', text: 'MarkdownV2' },
		];

		let buttonTypes = [
			{ value: 'url', text: 'URL' },
			{ value: 'callback_data', text: 'Callback Data' },
		];

		let keyboardTypes = [
			{ value: 'none', text: 'Klavye Yok' },
			{ value: 'inline', text: 'Inline Keyboard (Mesaj altı butonlar)' },
		];

		let tag_filter = _.concat(
			[{ value: 'all', text: 'Hepsi' }],
			_.map(tagList, (it) => ({
				value: it._id,
				text: it.title,
			}))
		);

		let activeExcelData = telegram_type === 'telegramv2' ? webApiExcelData : excelData;
		let excelPageOptions = [];
		if (activeExcelData && activeExcelData.length) {
			excelPageOptions = _.map(activeExcelData, (it, index) => ({
				value: index,
				text: it.filename || `Sayfa ${index + 1}`,
			}));
		}

		let showList =
			telegram_type === 'telegram' && merged_excel_list && merged_excel_list.length
				? merged_excel_list
				: (activeExcelData && activeExcelData[this.state.excelpage] && activeExcelData[this.state.excelpage].data) || [];
		if (selectedTag !== 'all') {
			let selectedTagObj = _.find(tagList, { _id: selectedTag });
			let selectedTag_Text = selectedTagObj && selectedTagObj.title;
			showList = _.filter(showList, (it) => _.includes(it.tags, selectedTag_Text));
		}

		return (
			<div>
				<Grid>
					<GridColumn width={12}>
						<Segment className="scroll">
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									flexWrap: 'wrap',
									gap: '8px',
									marginBottom: '10px',
									paddingBottom: '10px',
									borderBottom: '1px solid #eee',
								}}
							>
								<Dropdown
									selection
									placeholder="Tip"
									style={{ minWidth: '160px' }}
									options={[
										{ value: 'telegram', text: 'Telegram Bot API' },
										{ value: 'telegramv2', text: 'Telegram Web API' },
									]}
									name="telegram_type"
									value={telegram_type}
									onChange={(e, { value }) =>
										this.setState({
											telegram_type: value,
											targets: [],
											excelpage: 0,
											selectedTelegram: telegramList && telegramList[0] && telegramList[0].value,
											selectedWebApiIntegration: webApiIntegrations && webApiIntegrations[0] && webApiIntegrations[0].value,
											parse_mode: value === 'telegramv2' ? '' : 'HTML',
											keyboard_type: 'none',
											inline_keyboard: [],
											current_row: [],
										})
									}
								/>
								{telegram_type === 'telegram' && telegramList && telegramList.length > 0 && (
									<Dropdown
										selection
										placeholder="Bot"
										options={telegramList}
										name="selectedTelegram"
										value={selectedTelegram}
										onChange={this.handleChange}
									/>
								)}
								{telegram_type === 'telegramv2' && webApiIntegrations && webApiIntegrations.length > 0 && (
									<Dropdown
										selection
										placeholder="Hesap"
										options={webApiIntegrations}
										name="selectedWebApiIntegration"
										value={selectedWebApiIntegration}
										onChange={this.handleChange}
									/>
								)}
								{excelPageOptions && excelPageOptions.length > 0 && (
									<Dropdown
										selection
										placeholder="Excel Sayfası"
										options={excelPageOptions}
										name="excelpage"
										value={this.state.excelpage}
										onChange={this.handleChange}
									/>
								)}
								{tagList && tagList.length > 0 && (
									<Dropdown
										selection
										placeholder="Etiket"
										options={tag_filter}
										name="selectedTag"
										value={selectedTag}
										onChange={this.handleChange}
									/>
								)}
								<div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
									<Button basic color="blue" size="small" onClick={() => this.setState({ openListModal: true })}>
										Seçili ({targets.length})
									</Button>
									<Button basic color="green" size="small" onClick={() => this.toggleAll(showList)}>
										Tümünü Seç
									</Button>
									<Button basic color="red" size="small" onClick={() => this.setState({ targets: [] })}>
										Temizle
									</Button>
								</div>
							</div>
							<Table className="phone">
								<Table.Header>
									<Table.Row>
										<Table.HeaderCell>İsim</Table.HeaderCell>
										<Table.HeaderCell>Etiketler</Table.HeaderCell>
										<Table.HeaderCell textAlign="center" width={2}></Table.HeaderCell>
									</Table.Row>
								</Table.Header>

								<Table.Body>
									{(telegram_type === 'telegram' ? this.state.excelLoading : webApiExcelLoading) ? (
										<Page.Loader></Page.Loader>
									) : showList && showList.length > 0 ? (
										_.map(showList, (it, i) => {
											let isCheck = !!_.find(targets, { Phone: it.Phone });
											let isBlackList = _.includes(blackList, '' + it.Phone);

											return (
												<Table.Row key={i} disabled={isBlackList}>
													<Table.Cell>{it.Name || it.Phone}</Table.Cell>
													<Table.Cell>
														{isBlackList && <Label color="black">BlackList</Label>}
														{it.tags && it.tags.length > 0 && (
															<div className="cl-labels tags-line">
																{_.map(it.tags, (tag) => {
																	let _tag = _.find(tagList, { title: tag });
																	if (_tag)
																		return (
																			<Label key={tag} style={{ color: _tag.color }}>
																				{_tag.title}
																			</Label>
																		);
																})}
															</div>
														)}
													</Table.Cell>
													<Table.Cell textAlign="center">
														<Checkbox checked={isCheck} onChange={(e, { checked }) => this.toggle(it, checked)} />
													</Table.Cell>
												</Table.Row>
											);
										})
									) : null}
								</Table.Body>
							</Table>
						</Segment>
					</GridColumn>

					<GridColumn width={4}>
						<Segment>
							<Form onSubmit={() => this.setState({ openModal: true })}>
								<Form.Dropdown
									label="Mesaj Tipi"
									selection
									options={messageTypes}
									name="message_type"
									value={message_type}
									onChange={this.handleChange}
								/>

								{message_type === 'text' ? (
									<>
										{telegram_type === 'telegram' && (
											<Form.Dropdown
												label="Format Modu"
												selection
												options={parseModes}
												name="parse_mode"
												value={parse_mode}
												onChange={this.handleChange}
											/>
										)}

										{parse_mode === 'HTML' && (
											<Form.Input
												fluid
												placeholder="Üst resim URL'si (opsiyonel)"
												label="Üst Görsel"
												name="header_image"
												value={this.state.header_image || ''}
												onChange={this.handleChange}
											>
												<input />
												<div className="image-upload" style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
													<label htmlFor="header-image-input">
														<Icon name="upload" color="grey" size="large" style={{ cursor: 'pointer' }} />
													</label>
													<Input
														id="header-image-input"
														type="file"
														name="header_image"
														accept="image/*"
														style={{ display: 'none' }}
														onChange={(e) => {
															let file = e.target.files[0];
															this.fileUpload(file, 'header_image');
														}}
													/>
												</div>
											</Form.Input>
										)}

										<Form.Field required>
											<div style={{ display: 'flex', marginBottom: '10px' }}>
												<label>Mesaj</label>
												{parse_mode === 'HTML' && (
													<Button.Group size="mini" style={{ marginLeft: 'auto' }}>
														<Popup
															content="Bold"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('b')}>
																	<Icon name="bold" />
																</Button>
															}
														/>
														<Popup
															content="Italic"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('i')}>
																	<Icon name="italic" />
																</Button>
															}
														/>
														<Popup
															content="Underline"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('u')}>
																	<Icon name="underline" />
																</Button>
															}
														/>
														<Popup
															content="Strikethrough"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('s')}>
																	<Icon name="strikethrough" />
																</Button>
															}
														/>
														<Popup
															content="Code"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('code')}>
																	<Icon name="code" />
																</Button>
															}
														/>
														<Popup
															content="Alıntı (Blockquote)"
															trigger={
																<Button type="button" icon onClick={() => this.addHTMLTag('blockquote')}>
																	<Icon name="quote left" />
																</Button>
															}
														/>
														<Popup
															content="Link Ekle"
															trigger={
																<Button type="button" icon onClick={() => this.addLink()}>
																	<Icon name="linkify" />
																</Button>
															}
														/>
													</Button.Group>
												)}
												{parse_mode !== 'HTML' && (
													<Button.Group size="mini" style={{ marginLeft: 'auto' }}>
														<Popup
															content="Bold (**text**)"
															trigger={
																<Button type="button" icon onClick={() => this.addMarkdownTag('**')}>
																	<Icon name="bold" />
																</Button>
															}
														/>
														<Popup
															content="Italic (__text__)"
															trigger={
																<Button type="button" icon onClick={() => this.addMarkdownTag('__')}>
																	<Icon name="italic" />
																</Button>
															}
														/>
														<Popup
															content="Üstü Çizgili (~~text~~)"
															trigger={
																<Button type="button" icon onClick={() => this.addMarkdownTag('~~')}>
																	<Icon name="strikethrough" />
																</Button>
															}
														/>
													</Button.Group>
												)}
												<Popup
													on="click"
													pinned
													trigger={
														<Button type="button" size="mini" icon style={{ marginLeft: '10px' }}>
															<Icon name="smile outline" />
														</Button>
													}
													content={<Picker onClick={this.onEmojiClick} set="google" />}
												/>
											</div>
											<Form.TextArea
												id="message_area"
												placeholder="Mesajınızı girin..."
												name="message"
												required
												value={message}
												onChange={this.handleChange}
												rows={6}
											/>
											{parse_mode === 'HTML' && (
												<small style={{ color: 'gray' }}>
													HTML etiketleri: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;s&gt;, &lt;code&gt;, &lt;a href=""&gt;,
													&lt;blockquote&gt;
												</small>
											)}
										</Form.Field>
									</>
								) : (
									<>
										<Form.Input
											fluid
											placeholder="Medya URL'si"
											label="URL"
											required
											name="message"
											value={message}
											onChange={this.handleChange}
										>
											<input />
											<div className="image-upload" style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
												<label htmlFor="file-input">
													<Icon name="upload" color="grey" size="large" style={{ cursor: 'pointer' }} />
												</label>
												<Input
													id="file-input"
													type="file"
													name="message"
													accept="*"
													style={{ display: 'none' }}
													onChange={(e) => this.handleFileInput(e)}
												/>
											</div>
										</Form.Input>
										<Form.Field>
											<div style={{ display: 'flex', marginBottom: '10px' }}>
												<label>Açıklama (Caption)</label>
												<Popup
													on="click"
													pinned
													trigger={
														<Button type="button" size="mini" icon style={{ marginLeft: 'auto' }}>
															<Icon name="smile outline" />
														</Button>
													}
													content={<Picker onClick={this.onEmojiClickCaption} set="google" />}
												/>
											</div>
											<Form.TextArea
												id="caption_area"
												placeholder="Medya açıklaması (opsiyonel)"
												name="caption"
												value={caption}
												onChange={this.handleChange}
												rows={3}
											/>
										</Form.Field>
									</>
								)}

								{telegram_type === 'telegram' && (
									<>
										<Divider />
										<Form.Dropdown
											label="Butonlar"
											selection
											options={keyboardTypes}
											name="keyboard_type"
											value={keyboard_type}
											onChange={this.handleChange}
										/>
										{keyboard_type === 'inline' && (
											<Form.Field>
												<Button type="button" color="blue" onClick={() => this.setState({ openKeyboardModal: true })}>
													<Icon name="keyboard" />
													Buton Düzenle ({inline_keyboard.length} satır, {current_row.length} aktif)
												</Button>
												{inline_keyboard.length > 0 && (
													<Button
														type="button"
														color="red"
														basic
														size="tiny"
														onClick={this.clearKeyboard}
														style={{ marginTop: '5px' }}
													>
														Klavyeyi Temizle
													</Button>
												)}
											</Form.Field>
										)}
									</>
								)}

								<Divider />

								{/* Gönderim Aralığı */}
								<Form.Field>
									<label>Gönderim Aralığı</label>
									<Dropdown
										options={time_options}
										scrolling
										selection
										value={this.state.selectedAralik}
										onChange={(e, { value }) => this.setState({ selectedAralik: value })}
									/>
									<p style={{ marginTop: '5px', fontFamily: 'monospace', fontSize: '10px' }}>İki mesaj arasındaki bekleme süresi</p>
								</Form.Field>

								<Divider />

								<Form.Field>
									<label>Gönderim Zamanı</label>
									<Button.Group style={{ marginBottom: '10px' }}>
										<Button
											type="button"
											basic={sending_date !== 'now'}
											primary={sending_date === 'now'}
											onClick={() => this.setState({ sending_date: 'now' })}
										>
											Şimdi
										</Button>
										<Button
											type="button"
											basic={sending_date !== 'next'}
											primary={sending_date === 'next'}
											onClick={() => this.setState({ sending_date: 'next' })}
										>
											İleri Tarih
										</Button>
									</Button.Group>
									{sending_date === 'next' && (
										<DatePicker
											selected={startDate}
											onChange={(date) => this.setState({ startDate: date })}
											minDate={new Date()}
											filterTime={filterPassedTime}
											showTimeSelect
											timeFormat="HH:mm"
											timeIntervals={5}
											dateFormat="dd/MM/yyyy HH:mm"
											timeCaption="Saat"
											locale={dateLocales.tr}
										/>
									)}
								</Form.Field>

								<Divider />

								<Form.Input
									label="Test Numarası"
									value={testNumber}
									name="testNumber"
									onChange={this.handleChange}
									placeholder="905XXXXXXXXX"
								/>
								<Form.Button
									type="button"
									className="test_send"
									primary
									disabled={!testNumber}
									loading={btnLoading}
									onClick={() => this.setState({ openTestModal: true })}
								>
									Test Gönder
								</Form.Button>

								<Form.Button type="submit" positive disabled={btnLoading} loading={btnLoading}>
									Gönder
								</Form.Button>
							</Form>
						</Segment>
					</GridColumn>
				</Grid>

				{/* Inline Keyboard Modal */}
				<Modal open={this.state.openKeyboardModal} onClose={this.closeModal} size="small">
					<Header icon="keyboard" content="Inline Keyboard Düzenle" />
					<Modal.Content>
						<Form>
							<Form.Group widths="equal">
								<Form.Input
									label="Buton Metni"
									placeholder="Buton yazısı"
									name="button_text"
									value={button_text}
									onChange={this.handleChange}
								/>
								<Form.Dropdown
									label="Buton Tipi"
									selection
									options={buttonTypes}
									name="button_type"
									value={button_type}
									onChange={this.handleChange}
								/>
							</Form.Group>

							{button_type === 'url' && (
								<Form.Input label="URL" placeholder="https://example.com" name="button_url" value={button_url} onChange={this.handleChange} />
							)}

							{button_type === 'callback_data' && (
								<Form.Input
									label="Callback Data"
									placeholder="button_action"
									name="button_callback_data"
									value={button_callback_data}
									onChange={this.handleChange}
								/>
							)}

							<Button.Group>
								<Button type="button" color="blue" onClick={this.addInlineButton}>
									<Icon name="plus" />
									Satıra Ekle
								</Button>
								<Button type="button" color="green" onClick={this.finishRow} disabled={current_row.length === 0}>
									<Icon name="check" />
									Satırı Tamamla
								</Button>
							</Button.Group>

							<Divider />

							<Header size="small">Mevcut Satır ({current_row.length} buton)</Header>
							{current_row.map((btn, idx) => (
								<Label key={idx} size="large">
									{btn.text}
									<Icon
										name="delete"
										onClick={() => {
											let newRow = [...current_row];
											newRow.splice(idx, 1);
											this.setState({ current_row: newRow });
										}}
									/>
								</Label>
							))}

							<Divider />

							<Header size="small">Tamamlanmış Satırlar</Header>
							{inline_keyboard.map((row, rowIdx) => (
								<div key={rowIdx} style={{ marginBottom: '10px' }}>
									<Label color="grey">Satır {rowIdx + 1}</Label>
									{row.map((btn, btnIdx) => (
										<Label key={btnIdx}>
											{btn.text}
											{btn.url && <Icon name="linkify" />}
											{btn.callback_data && <Icon name="reply" />}
										</Label>
									))}
									<Button
										size="mini"
										icon="delete"
										color="red"
										basic
										onClick={() => {
											let newKeyboard = [...inline_keyboard];
											newKeyboard.splice(rowIdx, 1);
											this.setState({ inline_keyboard: newKeyboard });
										}}
									/>
								</div>
							))}
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={this.closeModal}>Kapat</Button>
					</Modal.Actions>
				</Modal>

				{/* Gönderim Onay Modal */}
				<Modal open={this.state.openModal} onClose={this.closeModal} style={{ width: '900px', maxHeight: '600px' }}>
					<Header icon="telegram" content={`Mesaj Gönder (${targets.length} kişi)`} />
					<Modal.Content>
						<div style={{ maxHeight: '400px', overflowY: 'auto' }}>
							<Segment>
								<Header size="small">Mesaj Önizleme</Header>
								<div style={{ background: '#f0f0f0', padding: '15px', borderRadius: '10px', marginBottom: '15px' }}>
									{this.state.header_image && message_type === 'text' && (
										<img
											src={this.state.header_image}
											alt="header"
											style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px', borderRadius: '5px' }}
										/>
									)}

									{message_type === 'text' || (message_type === 'text' && this.state.header_image) ? (
										<div
											dangerouslySetInnerHTML={{
												__html: parse_mode === 'HTML' ? message : escapeHTML(message).replace(/\n/g, '<br>'),
											}}
											style={{ wordBreak: 'break-word' }}
										/>
									) : (
										<>
											<Label color="blue">{message_type.toUpperCase()}</Label>
											<div style={{ marginTop: '10px' }}>
												{message_type === 'image' && message && (
													<img src={message} alt="preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
												)}
												{message_type === 'video' && message && (
													<video src={message} controls style={{ maxWidth: '100%', maxHeight: '300px' }} />
												)}
												{caption && (
													<div style={{ marginTop: '10px' }}>
														<strong>Caption:</strong>
														<div
															dangerouslySetInnerHTML={{
																__html: parse_mode === 'HTML' ? caption : escapeHTML(caption).replace(/\n/g, '<br>'),
															}}
														/>
													</div>
												)}
											</div>
										</>
									)}

									{keyboard_type === 'inline' && inline_keyboard.length > 0 && (
										<div style={{ marginTop: '15px' }}>
											<Divider />
											{inline_keyboard.map((row, rowIdx) => (
												<Button.Group key={rowIdx} style={{ marginBottom: '5px' }}>
													{row.map((btn, btnIdx) => (
														<Button key={btnIdx} basic size="small">
															{btn.text}
															{btn.url && <Icon name="linkify" />}
														</Button>
													))}
												</Button.Group>
											))}
										</div>
									)}
								</div>

								<Table>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell>İsim</Table.HeaderCell>
											<Table.HeaderCell>Numara</Table.HeaderCell>
											<Table.HeaderCell>Etiketler</Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										{_.map(targets.slice(0, 10), (it, i) => (
											<Table.Row key={i}>
												<Table.Cell>{it.Name || it.name}</Table.Cell>
												<Table.Cell>{it.Phone || it.id}</Table.Cell>
												<Table.Cell>
													{it.tags && it.tags.length > 0 && (
														<div>
															{_.map(it.tags, (tag) => {
																let _tag = _.find(tagList, { title: tag });
																if (_tag)
																	return (
																		<Label key={tag} size="mini" style={{ color: _tag.color }}>
																			{_tag.title}
																		</Label>
																	);
															})}
														</div>
													)}
												</Table.Cell>
											</Table.Row>
										))}
										{targets.length > 10 && (
											<Table.Row>
												<Table.Cell colSpan={3} textAlign="center">
													<em>... ve {targets.length - 10} kişi daha</em>
												</Table.Cell>
											</Table.Row>
										)}
									</Table.Body>
								</Table>
							</Segment>
						</div>
					</Modal.Content>
					<Modal.Actions>
						<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
							<div>
								{sending_date === 'next' && (
									<p>
										<strong>Gönderim Zamanı:</strong> {moment(startDate).format('DD/MM/YYYY HH:mm')}
									</p>
								)}
							</div>
							<div>
								<Button color="red" onClick={this.closeModal}>
									<Icon name="remove" /> İptal
								</Button>
								<Button color="green" onClick={() => this.sendMessage(false)}>
									<Icon name="checkmark" /> Gönder
								</Button>
							</div>
						</div>
					</Modal.Actions>
				</Modal>

				{/* Test Modal */}
				<Modal open={this.state.openTestModal} onClose={this.closeModal} size="small">
					<Header content={`Test Mesajı (${testNumber})`} />
					<Modal.Content>
						<p>
							<strong>{testNumber}</strong> numarasına test mesajı göndermek istediğinizden emin misiniz?
						</p>
						<Segment>
							<div style={{ background: '#f0f0f0', padding: '15px', borderRadius: '10px' }}>
								{this.state.header_image && message_type === 'text' && (
									<img
										src={this.state.header_image}
										alt="header"
										style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px', borderRadius: '5px' }}
									/>
								)}

								{message_type === 'text' ? (
									<div
										dangerouslySetInnerHTML={{
											__html: parse_mode === 'HTML' ? message : escapeHTML(message).replace(/\n/g, '<br>'),
										}}
									/>
								) : (
									<>
										<Label color="blue">{message_type.toUpperCase()}</Label>
										<div style={{ marginTop: '10px' }}>
											{message_type === 'image' && message && (
												<img src={message} alt="preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
											)}
											{message_type === 'video' && message && (
												<video src={message} controls style={{ maxWidth: '100%', maxHeight: '300px' }} />
											)}
											{caption && (
												<div style={{ marginTop: '10px' }}>
													<strong>Caption:</strong>
													<div
														dangerouslySetInnerHTML={{
															__html: parse_mode === 'HTML' ? caption : escapeHTML(caption).replace(/\n/g, '<br>'),
														}}
													/>
												</div>
											)}
										</div>
									</>
								)}

								{keyboard_type === 'inline' && inline_keyboard.length > 0 && (
									<div style={{ marginTop: '15px' }}>
										<Divider />
										{inline_keyboard.map((row, rowIdx) => (
											<Button.Group key={rowIdx} style={{ marginBottom: '5px' }}>
												{row.map((btn, btnIdx) => (
													<Button key={btnIdx} basic size="small">
														{btn.text}
														{btn.url && <Icon name="linkify" />}
													</Button>
												))}
											</Button.Group>
										))}
									</div>
								)}
							</div>
						</Segment>
					</Modal.Content>
					<Modal.Actions>
						<Button color="red" onClick={this.closeModal}>
							<Icon name="remove" /> İptal
						</Button>
						<Button color="green" onClick={() => this.sendMessage(true)}>
							<Icon name="checkmark" /> Test Gönder
						</Button>
					</Modal.Actions>
				</Modal>

				{/* Seçili Liste Modal */}
				<Modal open={this.state.openListModal} onClose={this.closeModal} style={{ width: '900px', maxHeight: '600px' }}>
					<Header icon="users" content={`Seçilenler (${targets.length})`} />
					<Modal.Content>
						<div style={{ maxHeight: '500px', overflowY: 'auto' }}>
							<Table>
								<Table.Body>
									{_.map(targets, (it, i) => (
										<Table.Row key={i}>
											<Table.Cell>{it.Name || it.name}</Table.Cell>
											<Table.Cell>{it.Phone || it.id}</Table.Cell>
											<Table.Cell>
												{it.tags && it.tags.length > 0 && (
													<div>
														{_.map(it.tags, (tag) => {
															let _tag = _.find(tagList, { title: tag });
															if (_tag)
																return (
																	<Label key={tag} size="mini" style={{ color: _tag.color }}>
																		{_tag.title}
																	</Label>
																);
														})}
													</div>
												)}
											</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						</div>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={this.closeModal}>Kapat</Button>
					</Modal.Actions>
				</Modal>
			</div>
		);
	}
}

const stateToProps = (state) => {
	return {
		access: state.access,
		location: state.router.location,
		product: state.product.live,
		user: state.access.user.loggedUserObj,
	};
};

export default connect(stateToProps)(withTranslation()(TelegramBroadcast));
